import React from "react";
import RichText from "components/rich-text";
import CommonSlider from "components/common-slider";
import Image from "components/image";
import getModulePadding from "helpers/get-module-padding";
import StoreReviews from "components/store-reviews";

const settings = {
    className: "common-slider rich-text-lp",
    slidesToShow: 1,
    slidesToScroll: 1,
};

const RichTextLP = ({ data }) => {
    const { images, mainContent, videoUrls } = data;
    const cleanVideoUrls = videoUrls?.filter((video) => video !== null && video !== "").map((link) => {
        let modifiedLink = link.replace("watch?v=", "embed/");
        modifiedLink = modifiedLink.replace("&", "?");
        return modifiedLink;
    });

    return (
        <div className="container flex lg:flex-row flex-col">
            <div className={`inline ${getModulePadding()}`}>
                <div className={`inline ${(images?.length > 0 || cleanVideoUrls?.length > 0) && "w-full pr-4"}`}>
                    {(images?.length > 0 && (cleanVideoUrls?.length === 0 || !cleanVideoUrls)) && (
                        <div className="lg:w-1/2 float-right relative w-full lg:pl-4 lg:mb-0 mb-4 h-fit">
                            <CommonSlider settings={settings}>
                                {images?.map((image) => (
                                    <Image
                                        key={image._key}
                                        image={image?.asset}
                                        className="max-h-[325px]"
                                    />
                                ))}
                            </CommonSlider>
                        </div>
                    )}

                    {(cleanVideoUrls?.length > 0 && (images?.length === 0 || !images)) && (
                        <div className="inline float-right relative lg:w-1/2 w-full lg:pl-4 lg:mb-0 mb-4">
                            <CommonSlider settings={settings}>
                                {cleanVideoUrls?.map((video) => (
                                    <iframe height={375} src={video} title="Cover Guide" />
                                ))}
                            </CommonSlider>
                        </div>
                    )}
                    
                    <RichText
                        value={mainContent?.data}
                        data={{ template: "Homepage" }}
                        className="lp-richtext"
                    />
                    {data?.hasReviews && (
                        <div className="rich-text-lp-reviews">
                            <StoreReviews data={{ number: 5 }} className="richtext-lp-reviews !p-0" /> 
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RichTextLP;
